import {useWatch} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import DateRangeSelect from '@/components/date-range-select/DateRangeSelect';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';

import type {ExportOptionsFieldsProps} from '../../types/exportTypes';
import type {DateRangeOptions} from '../../utils/exportOptions';

const DateRangeOptionsFields = ({
  form,
}: ExportOptionsFieldsProps<DateRangeOptions>) => {
  const {t} = useTranslation();
  const [startDate, endDate] = useWatch({
    control: form.control,
    name: ['options.startDate', 'options.endDate'],
  });

  return (
    <FormField
      control={form.control}
      name="options.startDate"
      render={() => (
        <FormItem>
          <FormLabel>{t('Date range')}</FormLabel>
          <FormControl>
            <div className="flex">
              <DateRangeSelect
                value={{startDate, endDate}}
                onChange={range => {
                  form.setValue('options.startDate', range.startDate);
                  form.setValue('options.endDate', range.endDate, {
                    shouldValidate: true,
                  });
                }}
              />
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default DateRangeOptionsFields;
